import ReportTable from '../handlers/report-table'

onDomLoad(() => {
  $("[data-behaviour='report-navbar-display-options']")
    .off('click')
    .on('click', (event) => {
      const dataset = event.currentTarget.dataset
      window.modalCitizen.openModal('report-display-options-modal', {
        locales: JSON.parse(dataset.locales),
        currentLocale: dataset.currentLocale,
        currentShowAccountsAs: dataset.currentShowAccountsAs,
        currentShowAccountNumbers: dataset.currentShowAccountNumbers
          ? JSON.parse(dataset.currentShowAccountNumbers)
          : dataset.currentShowAccountNumbers,
      })
    })

  $("[data-behaviour='report-navbar-analytical-dimensions']")
    .off('click')
    .on('click', (event) => {
      const dataset = event.currentTarget.dataset
      window.modalCitizen.openModal('report-analytical-dimensions-modal', {
        formattedDimensions: JSON.parse(dataset.formattedDimensions),
        editDimensionsUrl: dataset.editDimensionsUrl,
      })
    })
})

$(document).on(
  'click',
  "[data-behaviour='report-table-expand-all']",
  (event) => {
    event.preventDefault()
    new ReportTable($(document)).expandAll()
  }
)

$(document).on(
  'click',
  "[data-behaviour='report-table-collapse-all']",
  (event) => {
    event.preventDefault()
    new ReportTable($(document)).collapseAll()
  }
)

$(document).on('click', "[data-behaviour='report-reset-expand']", (event) => {
  event.preventDefault()
  new ReportTable($(document)).resetReportSettings()
})

// Delegated: the download link is born disabled and re-rendered (enabled) by a
// turbo-stream once the table's matrix is cached, so we can't bind it directly.
$(document).on(
  'click',
  "[data-behaviour='download-report-as-xlsx']",
  (event) => {
    event.preventDefault()
    const link = event.currentTarget
    window.modalCitizen.openModal('report-xlsx-export-modal', {
      reportId: link.dataset.reportId,
      downloadUrl: link.getAttribute('href'),
    })
  }
)
